import React, { useState } from 'react'
import { LoginFormImport } from './Import'
const { Card, Button, Form, InputGroup, useFormik, ForgetPasswordSchema, UserRound, Logo, LockKeyhole, LuEye, LuEyeOff, SaveButton } = LoginFormImport

export default function ForgetPasswordForm(props) {

    const { setTogggle } = props
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)

    const initialValues = {
        // user: '',
        new_password: '',
        confirm_password: '',
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: ForgetPasswordSchema,

        onSubmit: (values, action) => {
            // console.log(values)
        },
    })

    return (
        <>
            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} >
                {/* <Card className="h-100 rounded-start-5 rounded-end-0" style={{ backgroundColor: '#F8FAFC' }}>
                    <Card.Header className="p-3 text-end" style={{ backgroundColor: 'unset' }}>
                        <span className='fs-6 fw-medium'>Already have an account ? <u style={{ color: '#21263c', cursor: 'pointer' }} onClick={() => setTogggle(false)}> Sign In </u></span>
                    </Card.Header>
                    <Card.Body className='p-5 d-flex align-items-center'>
                        <div className='flex-fill'>
                            <img src={Logo} alt="logo" className='img-fluid' style={{ height: '45px' }} />
                            <div className='mt-3'>
                                <h3>Forget Password</h3>
                                <p>Let's get started !!...</p>
                            </div> */}

                <div className='mb-2'>
                    <Form.Label className='fw-medium mb-1' style={{ color: 'grey' }}>{'New Password'}</Form.Label>
                    <InputGroup className="" size="md">
                        <InputGroup.Text id="basic-addon1"><LockKeyhole size={16} /></InputGroup.Text>
                        <Form.Control
                            className='login-input'
                            placeholder="Enter New Password"
                            aria-label="New Password"
                            aria-describedby="basic-addon1"
                            name='new_password'
                            type={showPassword ? 'text' : 'password'}
                            value={values.new_password || ''}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        <InputGroup.Text onClick={() => setShowPassword((prev) => !prev)} id="basic-addon1">
                            {showPassword ? <LuEyeOff /> : <LuEye />}
                        </InputGroup.Text>
                    </InputGroup>

                    {errors.new_password && touched.new_password ? (<span className='field_error'>{errors.new_password}</span>) : null}
                </div>

                <div className='mb-2'>
                    <Form.Label className='fw-medium mb-1' style={{ color: 'grey' }}>{'Confirm Password'}</Form.Label>
                    <InputGroup className="" size="md">
                        <InputGroup.Text id="basic-addon1"><LockKeyhole size={16} /></InputGroup.Text>
                        <Form.Control
                            className='login-input'
                            placeholder="Enter Confirm Password"
                            aria-label="Confirm Password"
                            aria-describedby="basic-addon1"
                            name='confirm_password'
                            type={showConfirmPassword ? 'text' : 'password'}
                            value={values.confirm_password || ''}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        <InputGroup.Text onClick={() => setShowConfirmPassword((prev) => !prev)} id="basic-addon1">
                            {showConfirmPassword ? <LuEyeOff /> : <LuEye />}
                        </InputGroup.Text>
                    </InputGroup>
                    {errors.confirm_password && touched.confirm_password ? (<span className='text-danger form_label' >{errors.confirm_password}</span>) : null}
                </div>
                <div className="d-flex justify-content-between align-items-center text-muted mt-3">
                    <span style={{ fontSize: '13px' }} className='me-2'>By continuing, you agree to the <u className='text-dark' style={{ cursor: 'pointer' }}> <a style={{ color: 'black' }} href="" target='_blank'>terms of service</a> </u> and <u className='text-dark' style={{ cursor: 'pointer' }}><a style={{ color: 'black' }} href="" target='_blank'>privacy policy</a></u>.</span>
                    <SaveButton button_name='SAVE' />
                </div>
                {/* </div> */}
                {/* </Card.Body>
                    <Card.Footer className="text-end" style={{ backgroundColor: 'unset' }}>
                        <Button type='submit' size='md' className='login_save_btn'>Reset</Button>
                    </Card.Footer>
                </Card> */}
            </Form>
        </>
    )
}